import { FC, memo, useState } from 'react';
import { Modal } from 'shared/ui';
import { Form } from 'features/Form';
import { unFormalizedZipApi } from 'entities/unFormalizedZip/api/unFormalizedZipApi';
import { UnFormalizedZipRequestDto } from 'shared/api';
import { useGlobalSpinner } from 'shared/hooks';
import { App } from 'antd';
import { UNFORMALIZED_ZIP_CREATE_FORM_FIELDS } from '../../../constants/unFormalizedZipConstants';
import styles from './UnFormalizedZipForm.module.scss';

interface UnFormalizedZipFormProps {
  engineId: number;
  onClose: () => void;
  onSuccess?: () => void;
}

export const UnFormalizedZipForm: FC<UnFormalizedZipFormProps> = memo(({
  engineId,
  onClose,
  onSuccess,
}) => {
  const { message } = App.useApp();
  const { showSpinner, hideSpinner } = useGlobalSpinner();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: { description: string; docUrlUuids?: string[] }) => {
    // FileUpload привязан к форме императивно через setFieldValue, поэтому required
    // на поле подстраховываем явной проверкой - иначе создаётся пустая запись.
    if (!data.docUrlUuids?.length) {
      message.warning('Прикрепите хотя бы один файл');
      return;
    }

    try {
      setIsSubmitting(true);
      showSpinner('Создание запроса...');

      const requestData: UnFormalizedZipRequestDto = {
        engineId,
        description: 'Empty',
        docUrlUuids: data.docUrlUuids,
        status: UnFormalizedZipRequestDto.status.NEW,
      };

      await unFormalizedZipApi.createUnFormalizedZip(requestData);

      message.success('Запрос успешно создан');
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error('Ошибка создания запроса:', error);
      message.error('Ошибка создания запроса');
    } finally {
      setIsSubmitting(false);
      hideSpinner();
    }
  };

  return (
    <Modal
      title="Прикрепить имеющийся ЗИП"
      open
      onCancel={onClose}
      width={600}
      footer={null}
    >
      <div className={styles.formContainer}>
        <Form
          fields={UNFORMALIZED_ZIP_CREATE_FORM_FIELDS}
          onSubmit={handleSubmit}
          onCancel={onClose}
          loading={isSubmitting}
          submitText="Добавить ЗИП"
          cancelText="Отмена"
        />
      </div>
    </Modal>
  );
});

UnFormalizedZipForm.displayName = 'UnFormalizedZipForm';
